/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentStatusDto } from './documentStatusDto';

export interface DocumentDto {
  id?: string;
  name?: string;
  filename?: string;
  documentNumber?: string;
  revisionNumber?: string;
  revisionTime?: string;
  documentType?: DocumentDto.DocumentTypeEnum;
  link?: string;
  fileType?: string;
  mimeType?: string;
  fileSize?: number;
  documentProcessStatus?: DocumentStatusDto;
}
export namespace DocumentDto {
  export const DocumentTypeEnum = {
    JobPackage: 'JOB_PACKAGE',
    Attachment: 'ATTACHMENT',
    Link: 'LINK',
    Model3D: 'MODEL_3D',
    Video: 'VIDEO',
  } as const;
  export type DocumentTypeEnum = (typeof DocumentTypeEnum)[keyof typeof DocumentTypeEnum];
}
